import { AxiosInstance } from 'axios';
import RedisCacheRepositoryInterface, {
  SyncStatusResultInterface,
} from "@/services/RedisCache/interfaces/redis-cache.interface";

export default class RedisCacheRepository implements RedisCacheRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async disableRedisCacheByWebsiteId(websiteId: number): Promise<void> {
    const request: any = {
      "website_id": websiteId,
    };

    await this.axios.patch('/redis-cache/disable', request);
  }

  public async enableRedisCacheByWebsiteId(websiteId: number): Promise<void> {
    const request: any = {
      "website_id": websiteId,
    };

    await this.axios.post('/redis-cache/enable', request);
  }


  public async getRedisCacheStatusByWebsiteId(websiteId: number): Promise<SyncStatusResultInterface> {
    const query = new URLSearchParams();
    query.set('website_id', websiteId.toString());
    query.set('sync', "false");

    const resp = await this.axios.get<SyncStatusResultInterface>(`/redis-cache/status?${query.toString()}`);

    return resp.data;
  }

  public async getRedisCacheSyncedStatusByWebsiteId(websiteId: number): Promise<void> {
    const query = new URLSearchParams();
    query.set('website_id', websiteId.toString());
    query.set('sync', "true");

    await this.axios.get(`/redis-cache/status?${query.toString()}`);
  }
}
